<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size md_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ pageName }}</i>
                    </dt>
                    <dd>
                        <table class="create_table">
                            <tr>
                                <td>
                                    <table class="data_table">
                                        <colgroup>
                                            <col width="5%" />
                                            <col width="35%" />
                                            <col width="15%" />
                                            <col width="36%" />
                                            <col width="*" />
                                        </colgroup>
                                        <thead>
                                            <tr class="text_center">
                                                <th>
                                                    <label class="checkbox-wrap">
                                                        <input
                                                            type="checkbox"
                                                            v-model="checkAll"
                                                            true-value="Y"
                                                            false-value="N"
                                                            @change="changeCheck()"
                                                        />
                                                        <i class="check-icon"></i>
                                                    </label>
                                                </th>
                                                <th>email</th>
                                                <th>name</th>
                                                <th>remark</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody class="text_center">
                                            <tr v-for="(item, idx) in notificationList">
                                                <td>
                                                    <label class="checkbox-wrap">
                                                        <input
                                                            type="checkbox"
                                                            v-model="item.CHECK_YN"
                                                            true-value="Y"
                                                            false-value="N"
                                                        />
                                                        <i class="check-icon"></i>
                                                    </label>
                                                </td>
                                                <td>
                                                    <label class="serial-wrap">
                                                        <input
                                                            type="text"
                                                            class="text_input w100p"
                                                            v-model="item.EMAIL"
                                                        />
                                                    </label>
                                                </td>
                                                <td>
                                                    <label class="serial-wrap">
                                                        <input
                                                            type="text"
                                                            class="text_input w100p"
                                                            v-model="item.NAME"
                                                        />
                                                    </label>
                                                </td>
                                                <td>
                                                    <label class="serial-wrap">
                                                        <input
                                                            type="text"
                                                            class="text_input w100p"
                                                            v-model="item.REMARK"
                                                        />
                                                    </label>
                                                </td>
                                                <td class="text_right">
                                                    <span class="in-btn-item">
                                                        <a
                                                            v-if="idx === notificationList.length - 1"
                                                            href="javascript:"
                                                            class="ico_btn_add"
                                                            @click="btnAddSerial()"
                                                        >
                                                            <span class="sr_only">{{ $t('BUTTON.GLOBAL.ADD') }}</span>
                                                        </a>
                                                        <a
                                                            href="javascript:"
                                                            class="ico_btn_remove"
                                                            @click="btnRemoveSerial(idx)"
                                                        >
                                                            <span class="sr_only">{{
                                                                $t('BUTTON.GLOBAL.REMOVE')
                                                            }}</span>
                                                        </a>
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </dd>
                    <dd class="scroll_btm">
                        <div class="btn_modal_wrap topLine">
                            <div class="btn_right">
                                <a href="javascript:" class="btn_white" @click="$emit('close')">
                                    {{ $t('BUTTON.GLOBAL.CANCEL') }}
                                </a>
                                <a href="javascript:" class="btn_blue" @click="onSave()">
                                    {{ $t('BUTTON.GLOBAL.APPLY') }}
                                </a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'notificationList',
    props: {
        reqSystem: { default: '' },
    },
    data() {
        return {
            pageName: 'Notification List',
            notificationList: [],
            checkAll: 'N',
        };
    },
    mounted() {
        if (SDLUtil.isNull(this.reqSystem)) {
            this.$emit('close');
        }
        this.onSearch();
    },
    computed: {},
    methods: {
        btnAddSerial() {
            this.notificationList.push({ CHECK_YN: '', EMAIL: '', NAME: '', REMARK: '' });
        },
        btnRemoveSerial(idx) {
            if (
                !SDLUtil.isNull(this.notificationList[idx].CHECK_YN) ||
                !SDLUtil.isNull(this.notificationList[idx].EMAIL) ||
                !SDLUtil.isNull(this.notificationList[idx].NAME) ||
                !SDLUtil.isNull(this.notificationList[idx].REMARK)
            ) {
                SDLUtil.confirm({
                    msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                    onOkEvt: () => {
                        this.notificationList.splice(idx, 1);
                    },
                });
            } else {
                this.notificationList.splice(idx, 1);
            }
        },
        changeCheck() {
            for (const iterator of this.notificationList) {
                iterator.CHECK_YN = this.checkAll;
            }
        },
        onSearch() {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/admin/tool/selectEmail.skp`,
                    qs.stringify({
                        reqSystem: this.reqSystem,
                    }),
                )
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    this.notificationList = resp.data.result.rowData;

                    if (SDLUtil.isNull(this.notificationList)) {
                        this.btnAddSerial();
                    }
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        onSave() {
            for (const data of this.notificationList) {
                if (SDLUtil.isNull(data.EMAIL.trim())) {
                    SDLUtil.alert('There is no email.');
                    return false;
                } else {
                    data.EMAIL = data.EMAIL.trim();
                }
            }

            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/admin/tool/saveEmail.skp`,
                    qs.stringify({
                        reqSystem: this.reqSystem,
                        approvalPath: JSON.stringify(this.notificationList),
                    }),
                )
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    this.onSearch();
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/tool/toolManagePopup.vue